<div id="text-progress-bar">
  <ion-progress-bar id="progress-bar" #progressBar value="{{ value }}" [style.height.px]="pxProgressBarHeight"></ion-progress-bar>
  <div id="p-text" [style.font-size.px]="pxFontSize">{{ text }}</div>
</div>
